export default __webpack_public_path__ + "static/media/redstoneImg.6e2ea880.png";